import React from 'react';
import {
  BarChart, Bar, XAxis, YAxis, CartesianGrid, Tooltip, ResponsiveContainer, Cell
} from 'recharts';

const COLORS = ['#22c55e', '#84cc16', '#f59e0b', '#f97316', '#ef4444'];

const ResponseTimeChart = ({ data, loading }) => {
  if (loading) {
    return (
      <div className="flex items-center justify-center h-64">
        <div className="animate-spin rounded-full h-8 w-8 border-b-2 border-primary" />
      </div>
    );
  }

  return (
    <div className="bg-card border border-border rounded-xl p-5">
      <div className="mb-4">
        <h3 className="font-semibold text-foreground">Response Time Distribution</h3>
        <p className="text-xs text-muted-foreground mt-0.5">How quickly customers respond to approval requests</p>
      </div>
      <ResponsiveContainer width="100%" height={220}>
        <BarChart data={data} margin={{ top: 5, right: 10, left: -20, bottom: 0 }}>
          <CartesianGrid strokeDasharray="3 3" stroke="var(--color-border)" />
          <XAxis dataKey="range" tick={{ fontSize: 11, fill: 'var(--color-muted-foreground)' }} />
          <YAxis tick={{ fontSize: 11, fill: 'var(--color-muted-foreground)' }} />
          <Tooltip
            contentStyle={{ background: 'var(--color-card)', border: '1px solid var(--color-border)', borderRadius: 8, fontSize: 12 }}
          />
          <Bar dataKey="count" name="Approvals" radius={[4, 4, 0, 0]}>
            {data?.map((_, i) => (
              <Cell key={i} fill={COLORS?.[i % COLORS?.length]} />
            ))}
          </Bar>
        </BarChart>
      </ResponsiveContainer>
    </div>
  );
};

export default ResponseTimeChart;
